import { backgroundGreen, backgroundOrange, black, orange } from '@/theme/colors'
import styled from 'styled-components'

export const DashboardWrapper = styled.div`
	background-color: ${backgroundOrange};
	flex: 1;
	overflow-y: auto;
	width: 100%;
`

export const DashboardContainer = styled.div`
	padding: 2rem 1.5rem;
	max-width: 1400px;
	margin: 0 auto;
`

export const DashboardHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 2rem;
	gap: 1rem;
	flex-wrap: wrap;
`

export const DashboardTitleSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
`

export const DashboardTitle = styled.h1`
	margin: 0;
	font-size: 2rem;
	font-weight: 700;
	color: #2c3e50;
`

export const TripCodeContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`

export const TripCodeLabel = styled.span`
	font-size: 0.875rem;
	color: #6c757d;
	font-weight: 500;
`

export const TripCode = styled.span`
	background: ${backgroundGreen};
	color: ${black};
	padding: 0.25rem 0.75rem;
	border-radius: 6px;
	font-size: 0.875rem;
	font-weight: 700;
	font-family: 'Courier New', monospace;
`

export const SettingsButtonContainer = styled.div`
	display: flex;
	align-items: center;
`

export const SettingsButton = styled.button`
	background: white;
	color: ${orange};
	border: 1px solid ${orange};
	padding: 0.625rem 1rem;
	border-radius: 8px;
	font-size: 0.875rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&:hover {
		background: ${orange};
		color: white;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	&:active {
		opacity: 0.85;
		transform: translateY(0);
	}
`

export const DashboardGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
	gap: 1.5rem;
`

export const DashboardCard = styled.div`
	background: white;
	border-radius: 12px;
	padding: 1.5rem;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	display: flex;
	flex-direction: column;
	gap: 1rem;
	transition: all 0.2s ease;

	&:hover {
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
		transform: translateY(-2px);
	}
`

export const DashboardCardHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 0.75rem;
`

export const DashboardCardIcon = styled.div`
	color: ${orange};
	display: flex;
	align-items: center;
	justify-content: center;
`

export const DashboardCardTitle = styled.h3`
	margin: 0;
	font-size: 1.25rem;
	font-weight: 600;
	color: #2c3e50;
`

export const DashboardCardDescription = styled.p`
	margin: 0 0 0.5rem 0;
	font-size: 0.875rem;
	color: #6c757d;
	line-height: 1.5;
`

export const DashboardCardContent = styled.div`
	flex: 1;
`

export const DashboardCardMetrics = styled.div`
	display: flex;
	gap: 2rem;
`

export const DashboardCardMetric = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;

	.metric-value {
		font-size: 2rem;
		font-weight: 700;
		color: #2c3e50;
		line-height: 1;
	}

	.metric-label {
		font-size: 0.875rem;
		color: #6c757d;
		font-weight: 500;
	}
`

export const DashboardCardFooter = styled.div`
	border-top: 1px solid #e9ecef;
	padding-top: 1rem;
	margin-top: auto;
`

export const NavigateButton = styled.button`
	width: 100%;
	background: ${orange};
	color: white;
	border: none;
	padding: 0.75rem 1rem;
	border-radius: 8px;
	font-size: 0.875rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover:not(:disabled) {
		opacity: 0.9;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	&:active:not(:disabled) {
		opacity: 0.85;
		transform: translateY(0);
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`

export const LoadingState = styled.div`
	padding: 4rem 2rem;
	text-align: center;
	color: #6c757d;
`

export const ErrorState = styled.div`
	padding: 4rem 2rem;
	text-align: center;
	color: #dc3545;
`

export const EmptyStateMessage = styled.div`
	font-size: 0.875rem;
	color: #6c757d;
	text-align: center;
	padding: 1rem 0;
`

export const DateInfoContainer = styled.div`
	margin-top: 1rem;
	font-size: 0.875rem;
	color: #6c757d;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`

export const CategoriesInfo = styled.div`
	margin-top: 1rem;
	font-size: 0.875rem;
	color: #6c757d;
`

export const ExpensesMessage = styled.div`
	margin-top: 1rem;
	font-size: 0.875rem;
	color: #6c757d;
`

